<template>
  <div class="open-report">
    <div class="notification alert alert-success" v-if="this.$route.path != reportPath">
      <div class="row">
        <div class="col-sm-9">
          <i class="fa fa-info-circle"></i> You currently have {{ article }} 
          <strong>{{ report.reportType }}</strong> in use <span v-if="report.reportAddress">for <strong>{{ report.reportAddress }}</strong></span>
        </div>
        <div class="col-sm-3 text-right">
          <router-link class="my-2 btn btn-success" :to="reportPath">
            <i class="fa fa-folder-open"></i> Open
          </router-link>
          <button class="my-2 btn btn-info" @click="close(report.uuid)">
            <i class="fa fa-window-close"></i> Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    CLOSE_REPORT
  } from '@/vuex/types'
  export default {
    name: 'OpenReport',
    props: {
      object: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    computed: {
      article () {
        if (['a', 'e', 'i', 'o', 'u'].includes(this.report.reportType.toLowerCase().charAt(0))) {
          return 'an'
        }
        return 'a'
      },
      reportPath () {
        switch (this.report.reportType) {
          case 'Incident Report':
            return '/247-incident-reports/edit/' + this.report.reportUuid
          case 'Inspection Report':
            return '/inspection-reports/edit/' + this.report.reportUuid
          case 'Property Photos':
            return '/property-photos/edit/' + this.report.reportUuid
          case 'Asbestos Report':
            return '/asbestos-reports/edit/' + this.report.reportUuid
          case 'OH&S Report':
            return '/ohs-reports/edit/' + this.report.reportUuid
          case 'ESM Report':
            return '/esm-reports/edit/' + this.report.reportUuid
          case 'Building Defect Report':
            return '/building-defect-reports/edit/' + this.report.reportUuid
          case 'Insurance Report':
            return '/insurance-reports/edit/' + this.report.reportUuid
          case 'Quote Request':
          case 'Work Order':
            return '/trades/edit/' + this.report.reportUuid
        }
      },
      report () {
        return {
          ...this.object
        }
      }
    },
    methods: {
      async close (openReportUuid) {
        await this.$store.dispatch(CLOSE_REPORT, openReportUuid)
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/displays/OpenReport.vue